import { render, staticRenderFns } from "./dic_info_list.vue?vue&type=template&id=76ce73c5&scoped=true"
import script from "./dic_info_list.vue?vue&type=script&lang=js"
export * from "./dic_info_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ce73c5",
  null
  
)

export default component.exports